import type { ApiBody, ApiQuery } from '../../../shared/api/contracts'
import type { AdminHealth, AdminStats } from '../../../shared/api/models'
import { apiGet, apiPost, apiPut } from './transport'

export async function fetchHealth(signal?: AbortSignal): Promise<AdminHealth> {
  return apiGet<'GET /admin/health'>('/admin/health', signal)
}

export async function fetchProviderSettings(signal?: AbortSignal) {
  return apiGet<'GET /admin/provider-settings'>('/admin/provider-settings', signal)
}

export async function updateProviderSettings(payload: ApiBody<'PUT /admin/provider-settings'>, signal?: AbortSignal) {
  return apiPut<'PUT /admin/provider-settings'>('/admin/provider-settings', payload, signal)
}

export async function fetchTechDatabaseOverview(signal?: AbortSignal) {
  return apiGet<'GET /admin/tech/database/overview'>('/admin/tech/database/overview', signal)
}

export async function fetchTechDatabaseTable(tableName: string, params?: ApiQuery<'GET /admin/tech/database/table/:tableName'>, signal?: AbortSignal) {
  const u = new URLSearchParams()
  if (params?.limit != null) u.set('limit', String(params.limit))
  if (params?.offset != null) u.set('offset', String(params.offset))
  const qs = u.toString()
  return apiGet<'GET /admin/tech/database/table/:tableName'>(`/admin/tech/database/table/${encodeURIComponent(tableName)}${qs ? `?${qs}` as const : ''}`, signal)
}

export async function resetTechDatabase(payload: ApiBody<'POST /admin/tech/database/reset'>, signal?: AbortSignal) {
  return apiPost<'POST /admin/tech/database/reset'>('/admin/tech/database/reset', payload, signal)
}

export async function seedTechDemoData(payload: ApiBody<'POST /admin/tech/database/seed'>, signal?: AbortSignal) {
  return apiPost<'POST /admin/tech/database/seed'>('/admin/tech/database/seed', payload, signal)
}

export async function fetchStats(sinceHours: number, signal?: AbortSignal): Promise<AdminStats> {
  return apiGet<'GET /admin/stats'>(`/admin/stats?sinceHours=${encodeURIComponent(String(sinceHours))}`, signal)
}

export async function fetchTechnicalMetrics(signal?: AbortSignal) {
  return apiGet<'GET /admin/tech/metrics'>('/admin/tech/metrics', signal)
}
